import React from "react";
import {
  Badge,
  Box,
  Chip,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import { consoleBlue, consoleSelectedBg, consoleSidebarBg } from "./constants";

const DashboardNavList = ({ activeKey, collapsed = false, items, onSelect }) => (
  <Box sx={{ height: "100%", display: "flex", flexDirection: "column", bgcolor: consoleSidebarBg }}>
    <Box sx={{ overflowY: "auto", py: 1 }}>
      <List dense sx={{ px: collapsed ? 0.75 : 1, py: 0.5 }}>
        {items.map((item) => {
          const selected = item.key === activeKey;
          const disabled = Boolean(item.disabled);
          const button = (
            <ListItemButton
              key={item.key}
              selected={selected}
              disabled={disabled}
              onClick={() => {
                if (!disabled) onSelect(item.key);
              }}
              sx={{
                borderRadius: "6px",
                color: disabled ? "#9aa0a6" : selected ? consoleBlue : "#3c4043",
                mb: 0.25,
                minHeight: 44,
                px: collapsed ? 0 : 1.5,
                py: 0.85,
                position: "relative",
                justifyContent: collapsed ? "center" : "flex-start",
                "&.Mui-selected": {
                  bgcolor: consoleSelectedBg,
                },
                "&.Mui-selected:hover": {
                  bgcolor: consoleSelectedBg,
                },
                "&:hover": {
                  bgcolor: selected ? consoleSelectedBg : "#eef3f8",
                },
                "&.Mui-disabled": {
                  opacity: 0.72,
                  color: "#9aa0a6",
                },
                "&.Mui-selected::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 8,
                  bottom: 8,
                  width: 3,
                  borderRadius: "0 4px 4px 0",
                  bgcolor: consoleBlue,
                },
              }}
            >
              {!!item.icon && (
                <ListItemIcon
                  sx={{
                    minWidth: collapsed ? 0 : 36,
                    color: disabled ? "#9aa0a6" : selected ? consoleBlue : "#5f6368",
                    justifyContent: "center",
                  }}
                >
                  {collapsed && item.badge ? (
                    <Badge color="primary" badgeContent={item.badge}>
                      {item.icon}
                    </Badge>
                  ) : item.icon}
                </ListItemIcon>
              )}
              {!collapsed && (
                <>
                  <ListItemText
                    primary={item.label}
                    secondary={item.description}
                    primaryTypographyProps={{ fontSize: 14, fontWeight: selected ? 700 : 500 }}
                    secondaryTypographyProps={{
                      color: selected ? "rgba(26, 115, 232, 0.78)" : "#5f6368",
                      fontSize: 11,
                      noWrap: true,
                    }}
                  />
                  {!!item.badge && (
                    <Chip
                      color="primary"
                      label={item.badge}
                      size="small"
                      sx={{ borderRadius: 1, height: 20, minWidth: 28 }}
                    />
                  )}
                </>
              )}
            </ListItemButton>
          );

          return collapsed ? (
            <Tooltip key={item.key} title={item.label} placement="right">
              <span>{button}</span>
            </Tooltip>
          ) : button;
        })}
      </List>
    </Box>
  </Box>
);

export default DashboardNavList;
